{/*
  旺 (wang) — "Prosperous / Flourishing"
  Built from pure SVG strokes: 日 (sun) left + 王 (king) right
  No <text> elements — renders identically everywhere.
*/}

const S = 2; // stroke weight for main logo

export function IreneLogo({ size = 36, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Irene — 旺 (prosperous)"
    >
      {/* Red rounded square background */}
      <rect width="48" height="48" rx="12" fill="#ed4c4c" />

      {/*
        旺 character in white
        Left radical: 日 (sun) — a box with a horizontal bar
        Right radical: 王 (king) — three horizontal bars + vertical
      */}
      <g stroke="#ffffff" strokeWidth={S} strokeLinecap="round" strokeLinejoin="round" fill="none">
        {/* ── 日 (sun) ── left side ── */}
        {/* Outer box */}
        <rect x="9" y="15" width="10" height="18" rx="0.5" />
        {/* Middle bar */}
        <line x1="9" y1="24" x2="19" y2="24" />

        {/* ── 王 (king) ── right side ── */}
        {/* Top horizontal */}
        <line x1="24" y1="15" x2="39" y2="15" />
        {/* Middle horizontal */}
        <line x1="24" y1="24" x2="39" y2="24" />
        {/* Bottom horizontal */}
        <line x1="22" y1="33" x2="40" y2="33" />
        {/* Vertical stroke down center */}
        <line x1="31.5" y1="15" x2="31.5" y2="33" />
      </g>
    </svg>
  )
}

export function IreneLogoMark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Irene — 旺"
    >
      {/* Red rounded square */}
      <rect width="32" height="32" rx="8" fill="#ed4c4c" />

      <g stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
        {/* 日 */}
        <rect x="6" y="10" width="7" height="12" rx="0.3" />
        <line x1="6" y1="16" x2="13" y2="16" />

        {/* 王 */}
        <line x1="16" y1="10" x2="26" y2="10" />
        <line x1="16" y1="16" x2="26" y2="16" />
        <line x1="15" y1="22" x2="27" y2="22" />
        <line x1="21" y1="10" x2="21" y2="22" />
      </g>
    </svg>
  )
}
